<!-- Copyright (c) 2023, Alix Mougenot (Au pied des Arbres), alix.mougenot@gmail.com -->
<!-- See license file. -->
<script setup lang="ts">
import { inject } from "vue";

import PrctList from "@/components/actors/PrctList.vue";
import { dentistKey } from "@/logic/provide";
import NavigationManager from "@/components/navigation/NavigationManager.vue";
import Navigation from "@/components/navigation/Navigation.vue";

const dentists = inject(dentistKey);
</script>

<template>
  <div v-if="!dentists || dentists.list.length === 0"></div>
  <NavigationManager v-else>
    <Navigation navKey="Base des praticiens">
      <PrctList />
    </Navigation>
  </NavigationManager>
</template>
<style lang="scss"></style>
